import { customFetch } from "@/util/customFetch";
import { BACKEND_API_PLACEHOLDER } from "@/../environment.config";

// sample data imports for offline dev purposes
const isOfflineDev = import.meta.env.VITE_OFFLINE_DEV === "true";
const { weatherData } = isOfflineDev ? await import("../tests/fixtures/Weather.js") : {};

export async function getWeather(siteId, lat, long) {
  if (isOfflineDev) return weatherData

  const params = siteId
    ? `site_id=${siteId}&lat=${lat}&lon=${long}`
    : `lat=${lat}&lon=${long}`

  return customFetch(BACKEND_API_PLACEHOLDER + `/api/v1/weather/latest?${params}`, 'GET')
}

export async function getForecast(siteId, lat, long) {
  if (isOfflineDev) return { periods: [] }

  const params = siteId
    ? `site_id=${siteId}&lat=${lat}&lon=${long}`
    : `lat=${lat}&lon=${long}`

  return customFetch(BACKEND_API_PLACEHOLDER + `/api/v1/weather/forecast?${params}`, 'GET')
}